import "./RequestQuote.module.css";
import Header from "@/reusable_sections/Header";
import StartYourProject from "./sections/StartYourProject";
import AssessmentForm from "./sections/AssessmentForm";
import ProtectionFaq from "./sections/ProtectionFaq";
import Footer from "@/reusable_sections/Footer";
export default function RequestQuotePage() {
  return <div>
      <Header />
      <StartYourProject />
      <AssessmentForm />
      <ProtectionFaq />
      <Footer />
    </div>;
}